import React from 'react';

import { useNavigation, useNavigationState } from '../../navigation';
import type { ChangeRequestsListFilterState } from './ChangeRequestsListFilters';

/**
 * Control the filtering of the change requests list.
 */
export function useChangeRequestsFilters() {
    const navigationState = useNavigationState();
    const { navigate } = useNavigation();

    const screen =
        navigationState.screen.type === 'change_requests' ? navigationState.screen : null;
    const overlay =
        navigationState?.overlay?.type === 'space' && navigationState.overlay.changeRequest
            ? navigationState.overlay
            : null;

    const filters: ChangeRequestsListFilterState = screen?.filters ?? {};

    const onFiltersChange = React.useCallback(
        (change: ChangeRequestsListFilterState) => {
            navigate(
                overlay
                    ? { background: (prev) => ({ ...prev, filters: change }) }
                    : { screen: (prev) => ({ ...prev, filters: change }) }
            );
        },
        [navigate, overlay]
    );

    return { filters, onFiltersChange };
}
